import { PUBLIC_BACKEND } from "$env/static/public";

var s = "";
if (!PUBLIC_BACKEND.includes("localhost")) {
  s = "s";
}


export const protocol = s;